import { getFirestore, collection, type CollectionReference } from 'firebase/firestore';
import { APP_ID } from '../../config/constants';

/** Firebase app đã được khởi tạo ở App.jsx trước khi v2 render — dùng instance mặc định. */
export const userCollection = (uid: string, name: string): CollectionReference =>
  collection(getFirestore(), 'artifacts', APP_ID, 'users', uid, name);
